/**
 * @generated SignedSource<<64c88cef029bc46fc6a2fe68ac9e0567>>
 * @relayHash cba6ce20d219b60b230ae7abbc8dfbfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showInviteButton_provider from '@atlassian/jira-relay-provider/src/jira-invite-button.relayprovider';
import shouldFetchProjectAccess_provider from '@atlassian/jira-relay-provider/src/jira-is-fetch-accesslevel-for-split-share-button-enabled.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "67688bd785c6b8a973ee02d9f893c0f256281de1c688dcdfbe72361625e99501",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": showInviteButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": shouldFetchProjectAccess_provider
    }
  }
};

export default node;
